import React , { useState , useEffect , useRef} from 'react';
import { produce } from 'immer';
import Cookies from 'js-cookie';
import {
    BrowserRouter as Router,
    Switch,
    useLocation ,
  } from "react-router-dom";


const fetchLangFromLocalStorage = ()=>{
    if( window.localStorage ){
        try {
            let lang = window.localStorage.getItem('appLanguage');
            if( lang ){
                return lang;
            }
        } catch (error) {
        }
    }
    return null;

}

const fetchLangFromNavigatorLanguage = () => {
    if (/^nl\b/.test(navigator.language)) {
        return 'nl';
    }
    return 'en';
}

const AppReducer = (  reducerData , setReducerData , authService ) => {
    let reducer = {};
    reducer.getCurrentLanguage = ()=>{
        return reducerData.currentLanguage;
    };

    reducer.recalculateCurrentLanguage = function(){
        const lang = fetchLangFromLocalStorage();
        if( lang ){
            return lang;
        }

        // check authed user displayLanguage
        if( authService.hasIdentity() ){
                let identity =authService.getCurrentIdentity();
            let displayLang = authService.getCurrentIdentity()?.user?.displayLanguage;
            if( displayLang ){
                return displayLang;
            }
        }


        // check browser language
        let langNav = fetchLangFromNavigatorLanguage();
        return langNav;
    };

    reducer.setCurrentLanguage = (language) => {
        if( window.localStorage ){
            window.localStorage.setItem('appLanguage' , (language + '').toString() );
        }

        reducerData = produce( reducerData , ( draft )=>{
            draft.currentLanguage = language;
        });
        setReducerData(reducerData);
    };

    reducer.setCurrentAccount = ( accountId ) => {
        reducerData = produce( reducerData , ( draft )=>{
            draft.currentAccount = accountId;
        });
        setReducerData(reducerData);
    }

    reducer.getCurrentAccountWithData = (  ) => {
        
        let availableAccounts = [];
        let currentUser = authService.getCurrentIdentity()?.user;
        const currentAccountId = reducer.getCurrentAccount();
        if( !currentUser || !currentAccountId ){
            return null;
        }
        if(  currentUser.managingAccounts && currentUser.managingAccounts.length > 0 ){
            availableAccounts = [...currentUser.managingAccounts] ;
        }
        if(   currentUser.managingSuppliers && currentUser.managingSuppliers.length > 0 ){
            availableAccounts = [ ...availableAccounts , ...currentUser.managingSuppliers] ;
        }

        for( let i = 0 ; i < availableAccounts.length ; i++ ){
            if( availableAccounts[i].id == currentAccountId){
                let currentAccount = { ...availableAccounts[i]};
                if( currentAccount.label ){
                    currentAccount.accountLabel = currentAccount.label ;
                }
                return currentAccount;
            }
        }
    }

    reducer.getCurrentAccount = () => {
        return reducerData.currentAccount;
    }

    reducer.getUserManangingAccounts = () => {
        let currentUser = authService.getCurrentIdentity()?.user;
        return getUserManangingAccounts(currentUser);
    }

    reducer.getLanguageFromLocalStorage = function() {
        return fetchLangFromLocalStorage();
    };

    reducer.getLanguageFromNavigatorLanguage = function() {
        return fetchLangFromNavigatorLanguage();
    };

    reducer.getAuthService = function(){
        return authService;
    }

    return reducer;
};

const getUserManangingAccounts = ( currentUser ) => {
    let availableAccounts = [];
    if( !currentUser   ){
        return null;
    }
    if(  currentUser.managingAccounts && currentUser.managingAccounts.length > 0 ){
        availableAccounts = [...currentUser.managingAccounts] ;
    }
    if(   currentUser.managingSuppliers && currentUser.managingSuppliers.length > 0 ){
        availableAccounts = [ ...availableAccounts , ...currentUser.managingSuppliers] ;
    }

    let foundAccounts = [];
    for( let i = 0 ; i < availableAccounts.length ; i++ ){
        let currentAccount = { ...availableAccounts[i]};
        if( currentAccount.label ){
            currentAccount.accountLabel = currentAccount.label ;
        }
        foundAccounts.push(currentAccount);
    }

    return foundAccounts;
}

const determinUserLanguageStartup  = ( appData ) => {
    const lang = fetchLangFromLocalStorage();
    if( lang ){
        return lang;
    }

    let langNav = fetchLangFromNavigatorLanguage();
    return langNav;
};

const useAppReducer = function(  appData , authService ){

    let location = useLocation();
    const mounted = useRef(false);
    const locationChangeMounted = useRef(false);

    const calculateCurrentAccount = ()=>{
        const match = location.pathname.match(/\/a\/ac\/([a-zA-Z0-9]+)/)   ;
        if( match === null ){
            let currentUser = authService.getCurrentIdentity()?.user;
            const userAccounts = getUserManangingAccounts(currentUser);
            if( userAccounts?.length > 0 ){
                return userAccounts[0].id;
            }
        } else {
            return match[1];
        }
    };

    const [ reducerData , setReducerData ] = useState({
        'currentLanguage' : determinUserLanguageStartup(appData),
        'languageSetByOrigin' : 'appData' ,
        'currentAccount' : calculateCurrentAccount() ,
    });

    useEffect(()=>{
        if( locationChangeMounted.current ){
            setReducerData(produce( reducerData , (draft)=>{
                draft.currentAccount = calculateCurrentAccount();
            }));
        }
        locationChangeMounted.current = true;
    } , [ location.pathname  ]);

    const reducerRef = useRef(null);
    let reducer = AppReducer( reducerData , setReducerData , authService) ;
    reducerRef.current = reducer;

    mounted.current = true;
    return reducer;
};

export default useAppReducer ;
